import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';

import { Heading, NamedLink, IconEmailSent, InlineTextButton, IconClose, PrimaryButton } from '../../components';

import css from './AuthenticationPage.module.css';

const EmailVerificationInfo = props => {
  const {
    name,
    email,
    onResendVerificationEmail,
    resendErrorMessage,
    sendVerificationEmailInProgress,
  } = props;

  const resendEmailLink = (
    <InlineTextButton rootClassName={css.modalHelperLink} onClick={onResendVerificationEmail}>
      <FormattedMessage id="AuthenticationPage.resendEmailLinkText" />
    </InlineTextButton>
  );

  const fixEmailLink = (
    <NamedLink className={css.modalHelperLink} name="ContactDetailsPage">
      <FormattedMessage id="AuthenticationPage.fixEmailLinkText" />
    </NamedLink>
  );

  return (
    <div className={css.content}>
      <NamedLink className={css.verifyClose} name="ProfileSettingsPage">
        <span className={css.closeText}>
          <FormattedMessage id="AuthenticationPage.verifyEmailClose" />
        </span>
        <IconClose rootClassName={css.closeIcon} />
      </NamedLink>
      
      <div className={css.emailVerificationContent}>
        <IconEmailSent className={css.modalIcon} />
        
        <Heading as="h1" rootClassName={css.modalTitle}>
          <FormattedMessage id="AuthenticationPage.verifyEmailTitle" values={{ name }} />
        </Heading>
        
        <p className={css.modalMessage}>
          <FormattedMessage id="AuthenticationPage.verifyEmailText" values={{ email }} />
        </p>
        
        {resendErrorMessage}

        <div className={css.bottomWrapper}>
          <div className={css.actionButtons}>
            {sendVerificationEmailInProgress ? (
              <div className={css.loadingState}>
                <PrimaryButton disabled>
                  <FormattedMessage id="AuthenticationPage.sendingEmail" />
                </PrimaryButton>
              </div>
            ) : (
              <PrimaryButton onClick={onResendVerificationEmail}>
                <FormattedMessage id="AuthenticationPage.resendEmailLinkText" />
              </PrimaryButton>
            )}
            
            <NamedLink className={css.modalHelperLink} name="ContactDetailsPage">
              <FormattedMessage id="AuthenticationPage.fixEmailLinkText" />
            </NamedLink>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationInfo;
